<template>
  <label class="base-toggle">
    <input class="checkbox"
           type="checkbox"
           :checked="isChecked"
           @click="onClick">

    <div class="slider"></div>
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        required: true
      },
      trueValue: {
        default: true
      },
      falseValue: {
        default: false
      },
      checked: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isChecked: _.isEqual(this.value, this.trueValue) || this.checked
      }
    },
    watch: {
      value() {
        this.isChecked = _.isEqual(this.value, this.trueValue)
      }
    },
    methods: {
      onClick(e) {
        const isCheckedPrevious = this.isChecked
        const isChecked = e.target.checked

        if (isCheckedPrevious !== isChecked) {
          this.$emit('change', isChecked ? this.trueValue : this.falseValue)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .base-toggle {
    position: relative;
    display: inline-block;
    width: 51px;
    height: 26px;
    background-color: #e5e5e5;
    border-radius: 13px;
    cursor: pointer;
  }

  .checkbox {
    display: none;
  }

  .slider {
    position: absolute;
    top: 4px;
    left: 5px;
    width: 18px;
    height: 18px;
    background-color: #fff;
    border-radius: 50%;
    transition: all .2s ease;
  }

  .checkbox:checked + .slider {
    left: 28px;
    background-color: map.get($colors, primary)
  }
</style>
